/**
 * セレクトボックスが選択状態であればクラスを追加します
 * @returns { void }
 */
export const select = () => {
  const elements = document.querySelectorAll( '.c-select' );

  elements.forEach( element => {
    const options = element.querySelectorAll( 'option' );

    for ( let i = 0; i < options.length; i++ ) {
      if ( options[ i ].getAttribute( 'value' ) != '' && options[ i ].getAttribute( 'selected' ) !== null ) {
        element.classList.remove( 'c-select--unselected' );
        break;
      }
      if ( options[ 0 ].getAttribute( 'value' ) != '' ) {
        element.classList.remove( 'c-select--unselected' );
      } else {
        element.classList.add( 'c-select--unselected' );
      }
    }

    element.addEventListener( 'change', function ( event ) {
      const options = event.target.querySelectorAll( 'option' );

      options.forEach( ( optionEl, index ) => {
        if ( event.target.selectedIndex === index ) {
          if ( optionEl.getAttribute( 'value' ) == ''  ) {
            element.classList.add( 'c-select--unselected' );
          } else {
            element.classList.remove( 'c-select--unselected' );
          }
        }
      } );
    } );
  } );
}
